module.exports = __webpack_public_path__ + "static/media/20_make_a.4f6aabc3.ogg";